<template>
	<div class="table-editor">
		<table class="data-table">
			<thead>
				<tr>
					<th v-for="meta in sortedMetaData" :key="meta.Field" :style="[meta.Width ? 'width: ' + meta.Width : '' ]">
						<span :title="meta.Help">
							{{ meta.DisplayName }}
						</span>
					</th>
					<th class="delete-column" v-if="getOption('canResetRow')" style="width: 50px"></th>
					<th class="delete-column" v-if="getOption('canDeleteRow')"></th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(record, recordIndex) in localRecords" :key="recordIndex" :style="record.__rowStyle">
					<td v-for="meta in sortedMetaData" :key="meta.Field"
						>
						<!-- Select input when SelectOptions is provided -->
						<select v-if="meta.DataType == 'select' && meta.SelectOptions" 
							v-model="record[meta.Field]"
							@change="handleChange(recordIndex, record, meta.Field, meta.Validator)"
							:class="{ 'invalid': validationState[`${recordIndex}-${meta.Field}`] && validationState[`${recordIndex}-${meta.Field}`].isValid === false }"
							:style="[meta.Width ? 'width: ' + meta.Width : '' ]">
							<option v-for="(opt, idx) in meta.SelectOptions" :key="idx" :value="opt.value">
								{{ opt.title }}
							</option>
						</select>

						<div v-else-if="meta.DataType == 'display'"
							:style="['white-space: nowrap', meta.Width ? 'width: ' + meta.Width : '' ]">
							{{ record[meta.Field] }}
						</div>
						
						<textarea v-else-if="meta.DataType == 'long-string'"
							rows="1"
							:id="meta.Field + '-Idx_' + recordIndex"	
							v-model="record[meta.Field]"
							@input="handleChange(recordIndex, record, meta.Field, meta.Validator)"
							:class="{ 'invalid': validationState[`${recordIndex}-${meta.Field}`] && validationState[`${recordIndex}-${meta.Field}`].isValid === false }"
							:style="['field-sizing: content' ]"
						></textarea>

						<!-- Regular input based on DataType -->
						<input v-else 
							:id="meta.Field + '-Idx_' + recordIndex"
							:type="getInputType(meta.DataType)" 
							:step="getNumberInputStep(meta)"
							v-model="record[meta.Field]"
							@input="handleChange(recordIndex, record, meta.Field, meta.Validator)"
							:class="{ 'invalid': validationState[`${recordIndex}-${meta.Field}`] && validationState[`${recordIndex}-${meta.Field}`].isValid === false }" />

						<div class="field-validation-message" v-if="validationState[`${recordIndex}-${meta.Field}`] && validationState[`${recordIndex}-${meta.Field}`].isValid == false">
							{{ validationState[`${recordIndex}-${meta.Field}`].message }}
						</div>

						<!-- //TODO: Test output -->
						<!-- <div>
							<small>{{ record[meta.Field] }}</small>
						</div> -->
					</td>
					<td class="actions-cell delete-column" v-if="getOption('canDeleteRow')">
						<button @click="deleteRow(recordIndex, record)" class="delete-btn no-tooltip no-tooltip-icon" title="Delete row" style="width: 80px">
							{{ getOption('removeButtonLabel') }}
						</button>
					</td>
					<td class="actions-cell reset-column" v-if="getOption('canResetRow')" style="width: 50px">
						<c-action-button 
							@click="resetRow(recordIndex, record)" 
							class="reset-btn no-tooltip-icon" 
							title="Reset row to defaults" 
							:id="'reset'"
							style="border: 1px solid #ccc"
						>
							<template v-slot:icon>
								<span style="color: rgba(0, 0, 0, .5);">
									<i class="fa-solid fa-rotate"></i>
								</span>
							</template>
							<template v-slot:text></template>
						</c-action-button>
					</td>
				</tr>
			</tbody>
			<tfoot v-if="getOption('hasFooter')">
				<tr>
					<th v-for="meta in sortedMetaData" :key="meta.Field" class="footer-cell">
						<div v-if="meta.FooterValue">
							{{ meta.FooterValue }}
						</div>
					</th>
					<th class="delete-column footer-cell " v-if="getOption('canDeleteRow')"></th>
					<th class="reset-column footer-cell " v-if="getOption('canResetRow')"></th>
				</tr>
			</tfoot>
		</table>

		<div class="add-row-container" v-if="getOption('canAddNewRow')">
			<button @click="addRow" class="add-btn">
				{{ getOption('addNewText') }}
			</button>
		</div>
	</div>
</template>






<script>
export default {
	name: 'DataTableEditor',

	emits: ["update"],

	props: {
		records: {
			type: Array,
			required: true
		},
		metaData: {
			type: Array,
			required: true
		},




		options: {
			type: Object,
			required: false,
		},
			//TODO: These are now obsolete. Remove them. Don't use them. Use `options` instead.
			//		See `getOption(code)` as well.
			canAddNewRow: {
				type: Boolean,
				default: true
			},
			canDeleteRow: {
				type: Boolean,
				default: true
			},
			canResetRow: {
				type: Boolean,
				default: false
			},
			hasFooter: {
				type: Boolean,
				default: true
			},
			newRowIfEmpty: {
				type: Boolean,
				default: false
			},
			removeButtonLabel: {
				type: String,
				required: false,
				default: () => "Delete"
			},
	},





	data()
	{
		return {
			localRecords: [],
			validationState: {}
		};
	},





	computed: {
		sortedMetaData()
		{
			if (!this.metaData) return;

			return [...this.metaData].sort((a, b) => a.DisplayOrder - b.DisplayOrder);
		}
	},





	watch: {
		// 'records': function(newRecords)
		// {
		// 	if (!newRecords) return;

		// 	console.log("watch.records(): newRecords=", newRecords);

		// 	// this.localRecords = newRecords.map(record => ({
		// 	// 	...record,
		// 	// 	isValid: true
		// 	// }));
		// 	this.localRecords = newRecords;

		// 	console.log("watch.records(): this.localRecords=", this.localRecords);

		// 	this.checkAndAddNewRowIfEmpty();
		// },

		records: {
			handler(newRecords)
			{
				console.log("🧀🧀🧀🧀 watch.records(): newRecords=", newRecords);

				// if (!newRecords) return;

				// this.localRecords = newRecords.map(record => ({
				// 	...record,
				// 	isValid: true
				// }));

				// console.log("watch.records(): this.localRecords=", this.localRecords);

				// this.checkAndAddNewRowIfEmpty();

				this.processRecords(newRecords);
			}, deep: true
		}
	},



	mounted()
	{
		this.init();
	},



	
	methods: {
		init()
		{
			this.processRecords(this.records);
		},



		processRecords(newRecords)
		{
			// console.log("processRecords(): newRecords=", newRecords);
			
			if (!newRecords) return;

			this.localRecords = newRecords.map(record => ({
				...record,
				isValid: true
			}));

			// console.log("processRecords(): this.localRecords=", this.localRecords);

			this.checkAndAddNewRowIfEmpty();
		},



		checkAndAddNewRowIfEmpty()
		{
			// console.log("checkAndAddNewRowIfEmpty(): this.newRowIfEmpty=", this.newRowIfEmpty);
			// console.log("checkAndAddNewRowIfEmpty(): this.records=", this.records);
			if (this.getOption('newRowIfEmpty') && this.localRecords.length == 0)
			{
				// console.log("checkAndAddNewRowIfEmpty(): NEW ROW ADDED");
				this.addRow();
			}
		},

		getInputType(dataType)
		{
			const typeMap = {
				number: 'number',
				date: 'date',
				string: 'text',
				display: '',
			};
			return typeMap[dataType] || 'text';
		},



		handleChange(recordIndex, record, field, validator)
		{
			// Run validation if validator exists
			if (validator)
			{
				const value = this.localRecords[recordIndex][field];
				const result = validator(value);

				console.log("-------------------------------------------------");
				// console.log("handleChange(): validator=", validator);

				let isValid = false;
				let message = "";
				if (typeof result === "boolean")
				{
					// Version 1: Just returns a true/false if valid
					isValid = result;
					message = "";
				}
				else
				{
					// Version 2: returns a result with more info.
					isValid = result.isValid;
					message = result.message;

					console.log("handleChange(V2): isValid=", isValid);
					console.log("handleChange(V2): message=", message);
				}
				this.validationState[`${recordIndex}-${field}`] = {
					isValid: false,
					message: message
				}
				this.validationState[`${recordIndex}-${field}`].isValid = isValid;
			}

			// Update the overall record validity
			this.updateRecordValidity(recordIndex);

			// Emit update event with all records
			this.emitUpdate("update", record, field);
		},



		// getDefaultValue(record, meta)
		// { 
		// 	return record[meta.Field];
		// },



		updateRecordValidity(recordIndex)
		{
			// Check if all fields in the record are valid
			const isValid = this.sortedMetaData.every(meta =>
			{
				const key = `${recordIndex}-${meta.Field}`;

				// If validation hasn't run or passed, consider it valid
				return this.validationState[key] && this.validationState[key].isValid !== false;
			});

			//this.$set(this.localRecords[recordIndex], 'isValid', isValid);
			this.localRecords[recordIndex].isValid = isValid;
		},



		deleteRow(recordIndex, record)
		{
			if (!confirm('Are you sure you want to clear and reset this row?'))
			{
				return;
			}

			this.localRecords.splice(recordIndex, 1);

			// Clean up validation state for this row
			const keysToDelete = Object.keys(this.validationState).filter(key =>
				key.startsWith(`${recordIndex}-`)
			);
			keysToDelete.forEach(key =>
			{
				this.$delete(this.validationState, key);
			});

			// Re-index validation state for rows after the deleted one
			const newValidationState = {};
			Object.keys(this.validationState).forEach(key =>
			{
				const [idx, field] = key.split('-');
				const index = parseInt(idx);
				if (index > recordIndex)
				{
					newValidationState[`${index - 1}-${field}`] = this.validationState[key];
				} else
				{
					newValidationState[key] = this.validationState[key];
				}
			});
			this.validationState = newValidationState;

			// Emit update event
			this.emitUpdate("delete", record, null);
			
		},


		resetRow(recordIndex, record)
		{
			if (!confirm('Are you sure you want to reset this row to default values?'))
			{
				return;
			}
			this.emitUpdate("reset", record, null);
		},



		emitUpdate(action, changedRecord, updatedField)
		{
			// console.log("emitUpdate(): action=", action);
			// console.log("emitUpdate(): changedRecord=", changedRecord);
			// console.log("emitUpdate(): updatedField=", updatedField);
			// console.log("emitUpdate(): changedRecord[updatedField]=", changedRecord[updatedField]);

			const data = {
				action: action,
				changedRecord: changedRecord,
				updatedField: updatedField,
				records: this.localRecords,
			};

			this.$emit('update', data);
		},



		addRow()
		{
			// Create a new empty record with all fields from metadata
			const newRecord = {};
			this.metaData.forEach(meta =>
			{
				// Set default values based on data type
				if (meta.DataType === 'number')
				{
					newRecord[meta.Field] = '';
				} else if (meta.DataType === 'date')
				{
					newRecord[meta.Field] = '';
				} else
				{
					newRecord[meta.Field] = '';
				}


				if (meta.NewRecordDefaultValue)
				{
					newRecord[meta.Field] = meta.NewRecordDefaultValue;
				}
			});
			newRecord.isValid = true;

			this.localRecords.push(newRecord);

			// Emit update event
			this.$emit('update', this.localRecords);
		},




		getOption(code)
		{
			const option = this.options ? this.options[code] : null;

			if (code == "canAddNewRow")
			{
				if (option == null) return true;	// Default value
				return option;
			}
			if (code == "canDeleteRow")
			{
				// console.log("canDeleteRow(): option=", option)
				if (option == null) return true;	// Default value
				return option;
			}
			if (code == "canResetRow")
			{
				// console.log("canResetRow(): option=", option)
				if (option == null) return false;	// Default value
				return option;
			}
			if (code == "resetButtonLabel")
			{
				if (option == null) return "Reset";	// Default value
				return option;
			}
			if (code == "hasFooter")
			{
				if (option == null) return true;	// Default value
				return option;
			}
			if (code == "newRowIfEmpty")
			{
				if (option == null) return false;	// Default value
				return option;
			}
			if (code == "removeButtonLabel")
			{
				if (option == null) return "Delete";	// Default value
				return option;
			}

			if (code == "addNewText")
			{
				if (option == null) return "Add Row";	// Default value
				return option;
			}

			// Not found.
			return null;
		},





		getNumberInputStep(meta)
		{
			return meta.NumberStep ? meta.NumberStep : "";
		}

	}
};
</script>






<style scoped lang="scss">
//@use "/assets/sass/styles-version-1.scss" as *;

.table-editor
{
	width: 100%;
	overflow-x: auto;
}

.data-table
{
	width: 100%;
	border-collapse: collapse;
	border: 1px solid #ddd;
}

.data-table th,
.data-table td
{
	/* border: 1px solid #ddd; */
	padding: 8px;
	text-align: left;
	vertical-align: top;
}
.data-table td
{
	padding-bottom: 0;
}

/* .data-table th
{
	background-color: #f2f2f2;
	font-weight: bold;
} */

/* 
	copied from `.standard-table` 
	We want a different header colour to the "hove over row" background colour.
*/
.data-table thead th
{
	background-color: #162f47;
	color: #ffffff;
	text-align: left;
	font-weight: bold;
}

.data-table input,
.data-table textarea,
.data-table select
{
	width: 100%;
	padding: 4px 8px;
	border: 1px solid #ccc;
	border-radius: 4px;
	box-sizing: border-box;
}

.data-table input.invalid,
.data-table select.invalid
{
	border: 2px solid #f44336;
	background-color: #ffebee;
}


.data-table .field-validation-message
{
	font-size: 80%;
	padding-top: 5px;
	color: #f44336;
	font-weight: 700;;
}


.data-table tr
{
	/* border: 1px solid transparent; */
}

.data-table tbody tr:hover
{
	background-color: #f5f5f5;
	border-left: 1px solid black;
}

.actions-cell
{
	text-align: center;
	white-space: nowrap;
}

.delete-btn
{
	padding: 4px 12px;
	background-color: #f44336;
	color: white;
	border: none;
	border-radius: 4px;
	cursor: pointer;
	font-size: 14px;
}

.delete-btn:hover
{
	background-color: #d32f2f;
}

.add-row-container
{
	margin-top: 16px;
	text-align: left;
}

.add-btn
{
	padding: 8px 16px;
	background-color: #4CAF50;
	color: white;
	border: none;
	border-radius: 4px;
	cursor: pointer;
	font-size: 14px;
	font-weight: bold;
}

.add-btn:hover
{
	background-color: #45a049;
}




.delete-column
{
	width: 125px;
}
.data-table td.delete-column
{
	text-align: right;
}




tfoot .footer-cell
{
	border-top: 5px double black;
}
</style>